module.exports = __webpack_public_path__ + "img/menu_team.00cb2f38.svg";